/*
 * Montrelio : barre d'achat collante de la fiche produit (mobile).
 * Visible quand le bouton principal est sorti de l'écran par le haut, masquée au pied de page.
 * Le bouton de la barre déclenche le vrai bouton « Ajouter au panier » du thème.
 * Prix et vignette suivent la variante choisie (observation du bloc prix et du champ id).
 */
(function () {
  if (window.__mStickyAtc) return;
  window.__mStickyAtc = true;

  var MQ = window.matchMedia('(max-width: 749px)');

  function mainButton() {
    return document.querySelector('.product-information .add-to-cart-button');
  }
  function mainPrice() {
    return document.querySelector('.product-information product-price');
  }
  function variantId() {
    var i = document.querySelector('.product-information input[name="id"]');
    return i ? i.value : null;
  }

  var images = {};
  try {
    var raw = document.getElementById('mStickyAtcData');
    if (raw) images = JSON.parse(raw.textContent);
  } catch (e) {}

  // Position calculée à chaque défilement (getBoundingClientRect) : plus fiable qu'un
  // IntersectionObserver, mis en veille par certains navigateurs et perdu au morph.
  var HEADER = 64; // sous l'en-tête collant, le bouton est déjà caché

  function render() {
    var bar = document.getElementById('mStickyAtc');
    if (!bar) return;
    var mb = mainButton();
    var f = document.querySelector('footer');
    var aboveFold = mb ? mb.getBoundingClientRect().bottom < HEADER : false;
    var footerSeen = f ? f.getBoundingClientRect().top < window.innerHeight : false;
    var show = MQ.matches && aboveFold && !footerSeen;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    var b = bar.querySelector('.m-sticky-atc__btn');
    if (b) b.tabIndex = show ? 0 : -1;
  }

  function sync() {
    var bar = document.getElementById('mStickyAtc');
    if (!bar) return;
    var price = mainPrice();
    if (price) {
      // Le bloc prix répète le prix courant (texte visible + libellé accessible) : on dédoublonne.
      var all = price.textContent.replace(/\s+/g, ' ').match(/\d[\d\s.]*,\d{2}\s?€/g) || [];
      var m = [];
      all.forEach(function (x) {
        x = x.trim();
        if (m.indexOf(x) === -1) m.push(x);
      });
      if (m.length) {
        var now = bar.querySelector('.m-sticky-atc__now');
        if (now) now.textContent = m[0].trim();
        var was = bar.querySelector('.m-sticky-atc__was');
        /* data-no-was (brouillon de présentation, 21.10.2026) : prix réel seul, jamais de barré. */
        if (m[1] && m[1] !== m[0] && !bar.hasAttribute('data-no-was')) {
          if (!was) {
            was = document.createElement('s');
            was.className = 'm-sticky-atc__was';
            bar.querySelector('.m-sticky-atc__price').appendChild(was);
          }
          was.textContent = m[1].trim();
        } else if (was) {
          was.remove();
        }
      }
    }
    var id = variantId();
    var v = id && images[id];
    var img = bar.querySelector('.m-sticky-atc__img');
    if (img && v && v.i && img.getAttribute('src') !== v.i) img.src = v.i;
    var bb = bar.querySelector('.m-sticky-atc__btn');
    // Disponibilité lue dans les données de la variante : le vrai bouton passe aussi
    // en désactivé pendant un ajout, ce qui ferait clignoter « Épuisé ».
    if (bb && !justAdded) {
      var soldOut = v ? v.a === false : false;
      bb.disabled = soldOut;
      bb.textContent = soldOut ? 'Épuisé' : 'Ajouter au panier';
    }
  }

  var justAdded = false;

  var syncTimer = null;
  function syncSoon() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 120);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      render();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  function attach() {
    render();
    syncSoon();
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.m-sticky-atc__btn');
    if (!b || b.disabled) return;
    var mb = mainButton();
    if (!mb) return;
    // 22.10.2026 : le bouton principal est hors écran, l'ajout passait inaperçu (« rien ne se passe »).
    // On autorise le tiroir à s'ouvrir pour CET ajout seulement (auto-open lu par cart-drawer.js
    // au moment de l'événement d'ajout) ; le réglage du thème reste inchangé pour le bouton principal.
    // Premier ajout de la visite : la fenêtre « Bienvenue » (montrelio-offre-modal.js) s'en charge,
    // ouvrir aussi le tiroir faisait passer les deux fenêtres l'une sur l'autre (flash).
    var moffPending = false;
    try { moffPending = !!(window.MOFF && window.MOFF.actif) && sessionStorage.getItem('moff_modal_vu') !== '1'; } catch (e) {}
    var drawer = document.querySelector('cart-drawer-component');
    var hadAuto = drawer && drawer.hasAttribute('auto-open');
    if (drawer && !hadAuto && !moffPending) {
      drawer.setAttribute('auto-open', '');
      setTimeout(function () { drawer.removeAttribute('auto-open'); }, 4000);
    }
    mb.click();
    // Le bouton principal est hors écran : on confirme l'ajout sur la barre elle-même.
    justAdded = true;
    b.textContent = 'Ajoutée ✓';
    setTimeout(function () {
      justAdded = false;
      sync();
    }, 2500);
  });

  // Variante, prix, ou bloc d'achat réinjecté par le thème : on se recâble.
  var moTimer = null;
  new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(attach, 150);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', syncSoon);
  if (MQ.addEventListener) MQ.addEventListener('change', render);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
})();
